export { default as StyledTable } from './components/StyledTable.vue'
export { default as StyledEmptyTable } from './components/StyledEmptyTableLayout.vue'



// WEBPACK FOOTER //
// ./src/app/components/common/tables/index.js